import { Injectable, RendererFactory2, ViewEncapsulation, Inject, DOCUMENT } from '@angular/core';


@Injectable()
export class LinkService {
    constructor(private _rendererFactory: RendererFactory2, @Inject(DOCUMENT) private _doc) {}

    /**
     * Inject the State into the bottom of the <head>
     */
    addTag(tag: LinkDefinition, forceCreation?: boolean) {
        try {
            const renderer = this._rendererFactory.createRenderer(this._doc, {
                id: '-1',
                encapsulation: ViewEncapsulation.None,
                styles: [],
                data: {}
            });

            const link = renderer.createElement('link');
            const head = this._doc.head;
            const selector = this._parseSelector(tag);

            if (head == null) {
                throw new Error('<head> not found within DOCUMENT.');
            }

            Object.keys(tag).forEach((prop: string) => {
                return renderer.setAttribute(link, prop, tag[prop]);
            });

            // remove if link exists
            let _link: any;
            if ((_link = this._doc.querySelector(selector))) {
                if (_link.parentNode) {
                    _link.parentNode.removeChild(_link);
                }
            }
            renderer.appendChild(head, link);
        } catch (e) {
            console.error('Error within linkService : ', e);
        }
    }

    private _parseSelector(tag: LinkDefinition): string {
        const attr: string = tag.rel ? 'rel' : 'hreflang';
        return `[${attr}="${tag[attr]}"]`;
    }
}

export declare type LinkDefinition = {
    charset?: string;
    crossorigin?: string;
    href?: string;
    hreflang?: string;
    media?: string;
    rel?: string;
    rev?: string;
    sizes?: string;
    target?: string;
    type?: string;
} & {
    [prop: string]: string;
};
